module.exports = __webpack_public_path__ + "assets/img/reverse-sweep.d85c27b4.jpg";